import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.707 5.293l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1 -1.414 -1.414l5.293 -5.293l-5.293 -5.293a1 1 0 0 1 1.414 -1.414","key":"svg-0"}]]

/**
 * IconChevronRightFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2hldnJvbi1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOS43MDcgNS4yOTNsNiA2YTEgMSAwIDAgMSAwIDEuNDE0bC02IDZhMSAxIDAgMSAxIC0xLjQxNCAtMS40MTRsNS4yOTMgLTUuMjkzbC01LjI5MyAtNS4yOTNhMSAxIDAgMCAxIDEuNDE0IC0xLjQxNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chevron-right-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronRightFilled = createReactComponent('filled', 'chevron-right-filled', 'ChevronRightFilled', __iconNode);

export default IconChevronRightFilled;